export const setToken = (token = '') => {
    localStorage.setItem('tokenapicidtech', JSON.stringify(token));    
}

export const getToken = () => {
    const token = JSON.parse(localStorage.getItem('tokenapicidtechgerenciamento'));
    if(token!==null){
        return token;
    }
    return JSON.parse(localStorage.getItem('tokenapicidtech'));
}

export const removeToken = () => {
    localStorage.removeItem('tokenapicidtech');
}

export const setTokenGerenciamento = (token = '') => {
    localStorage.setItem('tokenapicidtechgerenciamento', JSON.stringify(token));    
}

export const removeTokenGerenciamento = () => {
    localStorage.removeItem('tokenapicidtechgerenciamento');
}